import { render, staticRenderFns } from "./IcoMoveToFolder.vue?vue&type=template&id=24da3c70&scoped=true"
import script from "./IcoMoveToFolder.vue?vue&type=script&lang=js"
export * from "./IcoMoveToFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24da3c70",
  null
  
)

export default component.exports